import { Component, inject, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  FormsModule,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogContent,
  MatDialogRef,
  MatDialogTitle,
} from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';

export interface AddObjectKeyDialogData {
  existingKeys: string[];
  parentName: string;
}

export interface AddObjectKeyDialogResult {
  propertyName: string;
}

@Component({
  selector: 'sfo-form-field-add-object-key-dialog',
  templateUrl: './add-object-key-dialog.component.html',
  standalone: true,
  imports: [
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatFormFieldModule,
    MatButtonModule,
    MatDialogTitle,
    MatDialogContent,
    MatDialogActions,
  ],
})
export class AddObjectKeyDialogComponent implements OnInit {
  private fb: FormBuilder = inject(FormBuilder);

  readonly dialogRef: MatDialogRef<AddObjectKeyDialogComponent> = inject(
    MatDialogRef<AddObjectKeyDialogComponent>,
  );
  readonly data = inject<AddObjectKeyDialogData>(MAT_DIALOG_DATA);

  form: FormGroup;

  get propertyName(): FormControl {
    return this.form.get('propertyName') as FormControl;
  }

  ngOnInit(): void {
    this.form = this.fb.group({
      propertyName: ['', [Validators.required, this.validatePropertyName.bind(this)]],
    });
  }

  // Custom validator to check if the property name already exists
  validatePropertyName(control: FormControl<string | null>): { [key: string]: any } | null {
    const name: string | null = control.value;
    if (name) {
      const trimmedName = name.toLowerCase().trim();
      if (this.data.existingKeys.includes(trimmedName)) {
        return { propertyExists: true };
      }
    }
    return null;
  }

  onConfirm(): void {
    if (this.form.valid) {
      this.dialogRef.close(this.form.value as AddObjectKeyDialogResult);
    }
  }

  onCancel(): void {
    this.dialogRef.close();
  }
}
